import React from 'react';

const UNREAD_COUNT = 0;

function DropdownNotification() {
	return (
		<div className="navbar-item dropdown header-topbar-notify">
			<a
				href="#/"
				data-bs-toggle="dropdown"
				className="navbar-link header-topbar-notify__btn"
				aria-label="Notifications"
			>
				<i className="fa fa-bell" aria-hidden="true"></i>
				{/* Figma: blue status dot on the bell */}
				<span className="header-topbar-notify__dot" aria-hidden="true" />
				<span className="badge">{UNREAD_COUNT}</span>
			</a>
			<div className="dropdown-menu media-list dropdown-menu-end">
				<div className="dropdown-header">NOTIFICATIONS ({UNREAD_COUNT})</div>
				<div className="text-center w-300px py-3">
					No notification found
				</div>
			</div>
		</div>
	);
}

export default DropdownNotification;
